import React from "react";
import { connect } from "react-redux";
import { compose } from "recompose";
import styles from "./styles";
import { withStyles } from "@material-ui/core/styles";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import TablePagination from "@material-ui/core/TablePagination";
import Typography from "@material-ui/core/Typography";
import BuyerOrgHeader from "../../BuyerOrgHeader";
import { getBuyerList, handleUserStatus } from "../../../actions/organisation";
import { openSnackBar } from "../../../actions/snack-bar";
import AddRealtorModal from "../../../components/Organisation/AddRealtorModal";
import { CircularProgress } from "@material-ui/core";
import ViewBuyerDetailsModal from "../../Organisation/ShowingsList/ViewBuyerDetailsModal";
import { Link } from "react-router-dom";
import IconButton from "@material-ui/core/IconButton";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";

class OrgDashboard extends React.Component {
  state = {
    buyerList: [],
    pageSize: 10,
    pageNumber: 1,
    keyword: "",
    loading: false,
    count: 0,
    openBar: false
  };

  handleChangePage = (event, newPage) => {
    this.setState({ pageNumber: newPage + 1 }, () => {
      this.getList();
    });
  };

  componentDidMount() {
    this.getList();
  }

  getList = () => {
    this.setState({ loading: true });
    const { pageNumber, pageSize, keyword } = this.state;
    this.props
      .dispatch(getBuyerList(pageNumber, pageSize, keyword, "buyer"))
      .then(response => {
        this.setState({
          buyerList: response.data,
          count: response.count,
          loading: false
        });
      })
      .catch(err => {
        const message = err && err.message;
        this.props.dispatch(
          openSnackBar({
            message
          })
        );
      });
  };

  handleUser = (event, buyerId, status) => {
    this.setState({ loading: true });
    status = status === "active" ? "deactive" : "active";
    event.preventDefault();
    this.props
      .dispatch(handleUserStatus(buyerId, status))
      .then(response => {
        this.closeOpenBar();
        this.getList();
        this.props.dispatch(
          openSnackBar({
            message: response.message
          })
        );
      })
      .catch(err => {
        this.setState({ loading: false });
        const message = err && err.message;
        this.props.dispatch(
          openSnackBar({
            message
          })
        );
      });
  };

  setOpenBar = (buyerId, status) => {
    if (status) {
      this.closeOpenBar();
      return;
    }
    this.closeOpenBar();
    const { buyerList } = this.state;
    const foundIndex = buyerList.findIndex(x => x.id === buyerId);
    buyerList[foundIndex].openBar = true;
    this.setState({ buyerList });
  };

  closeOpenBar = () => {
    const { buyerList } = this.state;
    buyerList.map(r => {
      r.openBar = false;
    });
    this.setState({ buyerList });
  };

  viewBuyerDetails = userId => {
    this.props.dispatch({
      type: "VIEW_BUYER_DETAILS",
      payload: true,
      buyerId: userId,
      showReview: true
    });
  };
  render() {
    const { classes, showBuyerDetailsModal } = this.props;

    return (
      <div>
        <BuyerOrgHeader authentication={this.props.authentication} />
        <div className={classes.container}>
          <div className={classes.pageLoader}>
            {this.state.loading && <CircularProgress size={60} />}
          </div>
          <div className={classes.innerWrap}>
            <div className={classes.headingWrap}>
              <Typography variant="h2" className={classes.headingWrapheading}>
                Manage Buyers {!this.state.loading && `(${this.state.count})`}
              </Typography>
            </div>
            <div className={classes.dashboardTable}>
              <Table>
                <TableHead>
                  <TableRow>
                    <TableCell>Buyer Name</TableCell>
                    <TableCell>Email id</TableCell>
                    <TableCell>Mobile No. </TableCell>
                    <TableCell>Account Status</TableCell>
                    <TableCell>Options</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {this.state.buyerList.map(buyer => {
                    return (
                      <TableRow key={buyer.id}>
                        <TableCell component="th">
                          {buyer.first_name + " " + buyer.last_name}
                        </TableCell>
                        <TableCell> {buyer.email}</TableCell>
                        <TableCell> {buyer.phone}</TableCell>
                        <TableCell>
                          <div className={classes.accountStatusDropdown}>
                            {buyer.status === "active" ? (
                              <span className={classes.textSuccess}>
                                Active
                              </span>
                            ) : (
                                <span className={classes.textDanger}>
                                  Deactive
                              </span>
                              )}
                            <IconButton
                              aria-label="account of current user"
                              aria-controls="menu-appbar"
                              aria-haspopup="true"
                              onClick={this.handleMenu}
                              color="inherit"
                            >
                              <ExpandMoreIcon
                                onClick={() =>
                                  this.setOpenBar(buyer.id, buyer.openBar)
                                }
                              />
                            </IconButton>
                            {buyer.openBar && (
                              <div className={classes.StatusDropdown}>
                                {buyer.status === "deactive" ? (
                                  <Link
                                    to="#"
                                    onClick={e =>
                                      this.handleUser(e, buyer.id, buyer.status)
                                    }
                                    className={classes.textSuccess}
                                  >
                                    Active
                                  </Link>
                                ) : (
                                    <Link
                                      to="#"
                                      onClick={e =>
                                        this.handleUser(e, buyer.id, buyer.status)
                                      }
                                      className={classes.textDanger}
                                    >
                                      Deactive
                                  </Link>
                                  )}
                              </div>
                            )}
                          </div>
                        </TableCell>
                        <TableCell>
                          {" "}
                          <button
                            className={classes.viewDetailBtn}
                            onClick={() => this.viewBuyerDetails(buyer.id)}
                          >
                            View Details
                          </button>
                        </TableCell>
                      </TableRow>
                    );
                  })}
                </TableBody>
              </Table>
              {!this.state.loading && !this.state.buyerList.length && <Typography variant="h2" className={classes.noResultFound}>
                No Result Found
              </Typography>}
            </div>

            {!this.state.loading && (
              <TablePagination
                className={classes.paginationSection}
                component="div"
                count={this.state.count}
                rowsPerPageOptions={[]}
                rowsPerPage={10}
                page={this.state.pageNumber - 1}
                onChangePage={this.handleChangePage}
                backIconButtonProps={{
                  "aria-label": "previous page"
                }}
                nextIconButtonProps={{
                  "aria-label": "next page"
                }}
              />
            )}
          </div>
          <div className={classes.copyright}>
            @2019 SafeShowings. All Right <span>Reserved</span>
          </div>
        </div>
        {this.props.addRealtorModal && (
          <AddRealtorModal open={this.props.addRealtorModal} />
        )}
        {showBuyerDetailsModal && (
          <ViewBuyerDetailsModal open={showBuyerDetailsModal} />
        )}
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    updatingUser: state.users.updatingUser,
    addRealtorModal: state.modalHandler.addRealtorModal,
    showBuyerDetailsModal: state.modalHandler.viewBuyerDetails
  };
};
const mapActionsToProps = dispatch => {
  return {
    dispatch
  };
};

export default compose(
  connect(
    mapStateToProps,
    mapActionsToProps
  ),
  withStyles(styles)
)(OrgDashboard);
